import React from 'react';
import propTypes from 'prop-types';

export default function CommissionsTable({ commissions }) {
  if (typeof commissions !== 'object') {
    return (
      <div className='flex w-auto items-center justify-center text-center text-lg text-grey'>
        <span>No Information Found For This Carrier. Try again</span>
      </div>
    );
  }

  return (
    <table className='w-full'>
      <thead>
        <tr>
          {commissions[0].map((header, i) => (
            <th
              key={`${header}${i}`}
              className='min-w-[100px] bg-grey-lightest p-2 text-left font-medium'
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {commissions.map((commissionsArray, rowIndex) => {
          if (rowIndex > 0) {
            return (
              <tr key={rowIndex}>
                {commissionsArray.map((commission, cellIndex) => (
                  <td key={commission + cellIndex} className='p-2'>
                    {commission ? commission : '---'}
                  </td>
                ))}
              </tr>
            );
          }
          return null;
        })}
      </tbody>
    </table>
  );
}

CommissionsTable.propTypes = {
  commissions: propTypes.array
};
